import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_yard-care-expert/artifacts/q7gx4zc1_mist-transparent-logo.png";

const Footer = () => {
  const services = [
  'Irrigation Installation',
  'System Blueprints', 
  'Landscape Lighting',
  'Back Flow Testing',
  'Seasonal Maintenance'];


  const quickLinks = [
  { name: 'Home', path: '/' },
  { name: 'Services', path: '/services' },
  { name: 'Packages', path: '/packages' },
  { name: 'About Us', path: '/about' },
  { name: 'Gallery', path: '/gallery' },
  { name: 'Contact', path: '/contact' }];


  return (
    <footer className="bg-mist-dark text-mist-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="mb-6 flex items-center gap-4">
              <img
                src={LOGO_URL}
                alt="Mist Irrigation - Where Growth Begins"
                className="h-24 w-auto brightness-0 invert" />
              <a href="https://www.greensolutionscare.com" target="_blank" rel="noopener noreferrer">
                <img
                  src="https://customer-assets.emergentagent.com/job_yard-care-expert/artifacts/f2ftmdu2_image.png"
                  alt="Green Solutions"
                  className="h-14 w-auto brightness-0 invert" />
              </a>
            </div>
            <p className="font-body text-mist-light/80 leading-relaxed mb-6">
              Professional irrigation solutions for beautiful, healthy landscapes. 
              Quality parts, expert installation, lasting results.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 bg-mist-blue/20 rounded-full flex items-center justify-center hover:bg-landscape-green transition-colors"
                data-testid="social-facebook">

                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-mist-blue/20 rounded-full flex items-center justify-center hover:bg-landscape-green transition-colors"
                data-testid="social-instagram">

                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-mist-blue/20 rounded-full flex items-center justify-center hover:bg-landscape-green transition-colors"
                data-testid="social-twitter">

                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg font-bold mb-6">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service) =>
              <li key={service}>
                  <Link
                  to="/services"
                  className="font-body text-mist-light/80 hover:text-landscape-green transition-colors">

                    {service}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) =>
              <li key={link.path}>
                  <Link
                  to={link.path}
                  className="font-body text-mist-light/80 hover:text-landscape-green transition-colors"
                  data-testid={`footer-link-${link.name.toLowerCase().replace(/\s/g, '-')}`}>

                    {link.name}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-bold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-landscape-green mt-1 flex-shrink-0" />
                <span className="font-body text-mist-light/80">(724) 294-5999</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-landscape-green mt-1 flex-shrink-0" />
                <span className="font-body text-mist-light/80">info@mistirrigationllc.com</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-landscape-green mt-1 flex-shrink-0" />
                <span className="font-body text-mist-light/80">115 Petry Lane
                  <br />Zelionople, PA 16063

                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-mist-blue/30">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-body text-sm text-mist-light/60">
              © {new Date().getFullYear()} Mist Irrigation. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="font-body text-sm text-mist-light/60 hover:text-landscape-green transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="font-body text-sm text-mist-light/60 hover:text-landscape-green transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;